import React from "react"
import Base, { BaseProps } from "../../base"

const Progress = ({ fill, stroke, ...props }) => (
  <Base
    {...props}
    className="g-progress"
    fill="none"
    height="172"
    viewBox="0 0 172 172"
    width="172"
  >
    <circle cx="86" cy="86" fill={fill} r="86" />
    <rect
      height="69.7409"
      stroke={stroke}
      width="17.4891"
      x="76.9102"
      y="61.9275"
    />
    <rect
      fill={stroke}
      height="88.4261"
      width="18.4891"
      x="109.371"
      y="43.7427"
    />
    <rect
      height="55.1263"
      stroke={stroke}
      width="18.0105"
      x="43.9531"
      y="76.542"
    />
    <path
      d="M82.0624 56.8332C82.3382 56.8193 82.5504 56.5844 82.5365 56.3086L82.3088 51.8143C82.2948 51.5386 82.0599 51.3263 81.7841 51.3403C81.5083 51.3543 81.2961 51.5892 81.3101 51.8649L81.5125 55.8598L77.5176 56.0622C77.2418 56.0762 77.0295 56.3111 77.0435 56.5869C77.0575 56.8627 77.2924 57.0749 77.5682 57.0609L82.0624 56.8332ZM53.5977 69.4665C53.5977 69.1448 53.6062 68.8254 53.6231 68.5084L52.6246 68.4551C52.6067 68.7899 52.5977 69.1271 52.5977 69.4665H53.5977ZM53.8282 66.6044C53.9319 65.9686 54.0696 65.3449 54.2394 64.7354L53.276 64.4671C53.0965 65.1119 52.9509 65.7714 52.8413 66.4435L53.8282 66.6044ZM54.8537 62.9238C55.0931 62.3287 55.3642 61.7506 55.665 61.1916L54.7844 60.7178C54.4661 61.3093 54.1792 61.921 53.9259 62.5507L54.8537 62.9238ZM56.6639 59.5601C57.0278 59.0342 57.4199 58.5303 57.8382 58.0505L57.0845 57.3933C56.6417 57.9012 56.2266 58.4346 55.8415 58.9912L56.6639 59.5601ZM59.1738 56.6817C59.644 56.2511 60.1384 55.8471 60.6545 55.4721L60.0666 54.6631C59.5199 55.0604 58.9964 55.4882 58.4984 55.9442L59.1738 56.6817ZM62.2623 54.438C62.8154 54.1254 63.3878 53.8434 63.9773 53.5943L63.588 52.6732C62.9631 52.9372 62.3564 53.2361 61.7702 53.5675L62.2623 54.438ZM65.777 52.9532C66.384 52.7757 67.0053 52.6315 67.639 52.523L67.4701 51.5373C66.7985 51.6524 66.1398 51.8052 65.4963 51.9935L65.777 52.9532ZM69.539 52.308C69.8556 52.2902 70.1746 52.2812 70.4958 52.2812V51.2812C70.1559 51.2812 69.8182 51.2908 69.4831 51.3096L69.539 52.308ZM70.4958 52.2812C70.8413 52.2812 71.1835 52.292 71.5224 52.3131L71.5846 51.315C71.225 51.2926 70.862 51.2812 70.4958 51.2812V52.2812ZM73.5572 52.57C74.2355 52.6999 74.8977 52.8722 75.5424 53.0839L75.8543 52.1337C75.1695 51.909 74.466 51.7259 73.7454 51.5878L73.5572 52.57ZM77.4478 53.8454C78.0676 54.1393 78.6678 54.4708 79.2469 54.8369L79.7813 53.9917C79.1689 53.6045 78.5333 53.2534 77.8762 52.9418L77.4478 53.8454ZM80.9187 56.0356C81.1856 56.251 81.4467 56.4743 81.7019 56.7049L82.3723 55.9629C82.1035 55.72 81.8283 55.4848 81.5469 55.2576L80.9187 56.0356Z"
      fill={stroke}
    />
    <path
      d="M116.629 36.7363C116.905 36.7223 117.117 36.4874 117.103 36.2117L116.875 31.7174C116.861 31.4416 116.626 31.2294 116.351 31.2434C116.075 31.2573 115.862 31.4922 115.876 31.768L116.079 35.7629L112.084 35.9653C111.808 35.9793 111.596 36.2142 111.61 36.49C111.624 36.7657 111.859 36.978 112.135 36.964L116.629 36.7363ZM88.1641 49.3695C88.1641 49.0479 88.1726 48.7285 88.1895 48.4115L87.191 48.3582C87.1731 48.693 87.1641 49.0302 87.1641 49.3695H88.1641ZM88.3946 46.5075C88.4983 45.8717 88.636 45.248 88.8058 44.6385L87.8424 44.3702C87.6629 45.0149 87.5173 45.6744 87.4077 46.3466L88.3946 46.5075ZM89.4201 42.8269C89.6595 42.2318 89.9306 41.6537 90.2314 41.0947L89.3508 40.6208C89.0325 41.2124 88.7456 41.8241 88.4923 42.4538L89.4201 42.8269ZM91.2303 39.4632C91.5942 38.9373 91.9863 38.4333 92.4046 37.9535L91.6509 37.2964C91.2081 37.8043 90.793 38.3377 90.4079 38.8943L91.2303 39.4632ZM93.7402 36.5848C94.2104 36.1542 94.7048 35.7502 95.2209 35.3751L94.633 34.5662C94.0863 34.9635 93.5628 35.3913 93.0648 35.8473L93.7402 36.5848ZM96.8287 34.3411C97.3818 34.0285 97.9542 33.7465 98.5437 33.4974L98.1545 32.5763C97.5295 32.8403 96.9228 33.1392 96.3366 33.4706L96.8287 34.3411ZM100.343 32.8563C100.95 32.6787 101.572 32.5346 102.205 32.4261L102.037 31.4404C101.365 31.5555 100.706 31.7083 100.063 31.8965L100.343 32.8563ZM104.105 32.2111C104.422 32.1933 104.741 32.1843 105.062 32.1843V31.1843C104.722 31.1843 104.385 31.1938 104.049 31.2126L104.105 32.2111ZM105.062 32.1843C105.408 32.1843 105.75 32.1951 106.089 32.2162L106.151 31.2181C105.791 31.1957 105.428 31.1843 105.062 31.1843V32.1843ZM108.124 32.473C108.802 32.603 109.464 32.7753 110.109 32.9869L110.421 32.0368C109.736 31.8121 109.032 31.629 108.312 31.4909L108.124 32.473ZM112.014 33.7485C112.634 34.0424 113.234 34.3739 113.813 34.74L114.348 33.8948C113.735 33.5076 113.1 33.1565 112.443 32.8449L112.014 33.7485ZM115.485 35.9387C115.752 36.1541 116.013 36.3773 116.268 36.6079L116.939 35.866C116.67 35.6231 116.395 35.3878 116.113 35.1606L115.485 35.9387Z"
      fill={stroke}
    />
    <path
      d="M94.375 72.5383V72.2941L76.875 89.7417V89.986L94.375 72.5383Z"
      fill={stroke}
    />
    <path
      d="M94.375 69.363V69.1188L76.875 86.6013V86.8456L94.375 69.363Z"
      fill={stroke}
    />
    <path
      d="M94.375 75.7137V75.4695L76.875 92.9171V93.1614L94.375 75.7137Z"
      fill={stroke}
    />
    <path
      d="M94.375 66.1873V65.943L76.875 83.4255V83.6698L94.375 66.1873Z"
      fill={stroke}
    />
    <path
      d="M94.375 85.2053V84.9611L76.875 102.444V102.688L94.375 85.2053Z"
      fill={stroke}
    />
    <path
      d="M94.375 82.0647V81.7855L76.875 99.2681V99.5123L94.375 82.0647Z"
      fill={stroke}
    />
    <path
      d="M94.375 78.8893V78.645L76.875 96.0927V96.3369L94.375 78.8893Z"
      fill={stroke}
    />
    <path
      d="M94.375 63.0121V62.7678L76.875 80.2504V80.4946L94.375 63.0121Z"
      fill={stroke}
    />
    <path
      d="M82.685 62H82.44L76.875 67.5484V67.7926L82.685 62Z"
      fill={stroke}
    />
    <path d="M79.535 62H79.29L76.875 64.4078V64.652L79.535 62Z" fill={stroke} />
    <path d="M85.87 62H85.625L76.875 70.7238V70.9681L85.87 62Z" fill={stroke} />
    <path d="M92.24 62H91.995L76.875 77.0748V77.319L92.24 62Z" fill={stroke} />
    <path
      d="M89.055 62H88.81L76.875 73.8993V74.1436L89.055 62Z"
      fill={stroke}
    />
    <path
      d="M94.375 88.3809V88.1366L76.875 105.619V105.863L94.375 88.3809Z"
      fill={stroke}
    />
    <path
      d="M94.3739 123.276V123.032L85.3789 132H85.6239L94.3739 123.276Z"
      fill={stroke}
    />
    <path
      d="M94.375 113.75V113.506L76.875 130.953V131.232L94.375 113.75Z"
      fill={stroke}
    />
    <path
      d="M94.3748 116.925V116.681L79.0098 132H79.2898L94.3748 116.925Z"
      fill={stroke}
    />
    <path
      d="M94.3753 120.101V119.857L82.1953 132H82.4403L94.3753 120.101Z"
      fill={stroke}
    />
    <path
      d="M94.3764 126.417V126.173L88.5664 132H88.8114L94.3764 126.417Z"
      fill={stroke}
    />
    <path
      d="M94.375 129.592V129.348L91.75 132H91.995L94.375 129.592Z"
      fill={stroke}
    />
    <path
      d="M94.375 94.7318V94.4875L76.875 111.935V112.179L94.375 94.7318Z"
      fill={stroke}
    />
    <path
      d="M94.375 101.083V100.839L76.875 118.286V118.53L94.375 101.083Z"
      fill={stroke}
    />
    <path
      d="M94.375 97.9074V97.6631L76.875 115.111V115.355L94.375 97.9074Z"
      fill={stroke}
    />
    <path
      d="M94.375 91.5563V91.312L76.875 108.76V109.039L94.375 91.5563Z"
      fill={stroke}
    />
    <path
      d="M94.375 110.574V110.33L76.875 127.813V128.057L94.375 110.574Z"
      fill={stroke}
    />
    <path
      d="M94.375 104.223V103.979L76.875 121.462V121.706L94.375 104.223Z"
      fill={stroke}
    />
    <path
      d="M94.375 107.399V107.155L76.875 124.637V124.881L94.375 107.399Z"
      fill={stroke}
    />
  </Base>
)

Progress.propTypes = BaseProps

export default Progress
